import { handleActions } from 'redux-actions';
import { LOCATION_CHANGE } from 'react-router-redux';
import { getFormValues } from 'redux-form';

import _cloneDeep from 'lodash/cloneDeep';
import _last from 'lodash/last';
import _isNaN from 'lodash/isNaN';
import _flow from 'lodash/flow';
import _get from 'lodash/get';

import http from '../../shared/http';
import endpoints from '../../../config/endpoints';
import intl from '../../shared/intl';
import checkPermissions from '../../shared/check-permissions';
import {
	createSelectOptionsFromSysEnums,
	createSelectOptionsFromSysEnumsForCountries
} from '../../shared/form-elements/select/index';

import createGeneralForm from '../components/forms/general';

const mainForm = createGeneralForm({
	namespace: 'applicantEditor',
	stateNodeName: 'mainForm'
});

const TOGGLE_PROGRESS_BAR = 'applicantEditor/toggle-progress-bar';
const FETCH_APPLICANT_SUCCESS = 'applicantEditor/fetch-applicant-success';
const FETCH_ERROR = 'applicantEditor/fetch-error';
const GET_EMPTY_DATA = 'applicantEditor/get-empty-data';

export const allowedPermissions = {
	'view': 'affiliates_list',
	'edit': 'affiliates_update'
};

const initialState = {
	data: null,
	applicant: null,
	showProgressBar: false,
	mainForm: mainForm.initialState,
	error: false
};

const addIdToEmail = options => options.map(({value, label}) => ({ value, label: `${label}(${value})` }));

const loadOptions = (entity = 'affiliates', fns, addToQuery = '') =>
	text => dispatch => {
		const request = http({
			url: `${endpoints.LOOKUPS[entity.toUpperCase()]}?query=${text + addToQuery}`,
			method: 'get',
			actions: [
				`applicantEditor/fetch-${entity}-form-success`,
				`applicantEditor/fetch-${entity}-form-error`
			]
		});
		return request(dispatch)
			.then(action => {
				if (action.type === `applicantEditor/fetch-${entity}-form-success`) {
					return {
						options: _flow(...fns)(action.payload.data)
					};
				}
			});
	};

export const actions = Object.assign({

	fetchData: () => dispatch => {
		const { pathname } = window.location;
		let lastParams = parseInt(_last(pathname.split('/')));

		if (_isNaN(lastParams)) return setTimeout(() => dispatch(actions.getEmptyData()), 0);

		const request = http({
			url: `${endpoints.APPLICANTS.BASE}/${lastParams}`,
			method: 'get',
			actions: [ FETCH_APPLICANT_SUCCESS, FETCH_ERROR ]
		});

		return request(dispatch);
	},

	toggleProgressBar: () => ({ type: TOGGLE_PROGRESS_BAR }),

	getEmptyData: () => ({ type: GET_EMPTY_DATA}),

	loadAffiliateOptions: loadOptions('affiliates', [
		createSelectOptionsFromSysEnums, addIdToEmail
	]),

	loadAdminsOptions: loadOptions('admins', [
		createSelectOptionsFromSysEnums, addIdToEmail
	]),

	loadCountriesOptions: loadOptions('locations', [
		createSelectOptionsFromSysEnumsForCountries
	]),

	loadLocationOptions: text => ( dispatch, getState ) => {
		const countryId = _get(
			getFormValues('applicantMainForm')(getState()),
			['country_id', 0, 'value']
		);
		return loadOptions('locations_by_country', [
			createSelectOptionsFromSysEnumsForCountries
		], `&country=${countryId || 0}`)(text)(dispatch);
	}
},
mainForm.actions
);

const reducers = Object.assign({

	[GET_EMPTY_DATA]: (state, action) => ({
		...state,
		data: {},
		showProgressBar: false
	}),

	[LOCATION_CHANGE]: (state, action) => {
		return action.payload.pathname.indexOf('applicants/edit') === -1 ? initialState : state;
	},

	[FETCH_APPLICANT_SUCCESS]: (state, action) => {
		return {
			...state,
			data: action.payload.data,
			applicant: action.payload.data,
			showProgressBar: false
		};
	},

	[FETCH_ERROR]: state => ({ ...state, error: true, showProgressBar: false}),
	[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: !state.showProgressBar })

},
mainForm.reducers
);

export default handleActions(reducers, _cloneDeep(initialState));

export const selectors = {
	getData: state => state.applicantEditor.data,
	getIntl: state => intl(state),
	getCan: state => checkPermissions(state, allowedPermissions),
	getProgressBar: state => state.applicantEditor.showProgressBar,
	getMainFormData: mainForm.selectors.getMainFormData,
	getError: state => state.applicantEditor.error
};


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/applicants/editor/index.js